import * as React from "react";
import { useRef } from "react";
import css from "./select-field.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
const SelectField = ({
  value,
  onChange,
  autoComplete,
  children
}) => {
  const inputRef = useRef();
  const clicked = () => {
    inputRef.current.focus();
  };
  const changed = e => {
    if (onChange) onChange(e);
  };
  return _jsx("div", {
    className: css.selectfield,
    onClick: clicked,
    children: _jsx("select", {
      autoComplete: autoComplete,
      className: css.input,
      value: value,
      ref: inputRef,
      onChange: changed,
      children: children
    })
  });
};
export default SelectField;